import { createStore } from 'vuex'
import auth from './auth'
import device from './device'
import geolocation from './geolocation'
import map from './map'

const store = createStore({
  modules: {
    auth,
    device,
    geolocation,
    map,
  },
  mutations: {
    initStore(state) {
      if (!localStorage) {
        return;
      }
      if (localStorage.getItem('store')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        );
      }
    }
  }
});

store.subscribe((mutation, state) => {
  if (!localStorage) {
    return;
  }

  if (mutation.type.startsWith('map/')) {
    let store = {
      map: state.map
    }
    localStorage.setItem('store', JSON.stringify(store));
  }
});

export default store